import { Directive, Input, HostBinding, ElementRef, OnInit, inject } from '@angular/core';
import { lazyLoad } from 'unlazy';
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[dolazy]',
  standalone: true,

  host: {
    loading: 'lazy',
    '(load)': 'load()',
  },
})
export class ImagePreloadDirective implements OnInit {
 private elementRef = inject(ElementRef);

  @Input() dolazy!: string | undefined;
  @HostBinding('class') className!: string;

  /* placeholderImg =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADxSURBVHgB7dFBAQAgDAChaf+cq6E17gEVOLv7how7pAiJERIjJEZIjJAYITFCYoTECIkREiMkRkiMkBghMUJihMQIiRESIyRGSIyQGCExQmKExAiJERIjJEZIjJAYITFCYoTECIkREiMkRkiMkBghMUJihMQIiRESIyRGSIyQGCExQmKExAiJERIjJEZIjJAYITFCYoTECIkREiMkRkiMkBghMUJihMQIiRESIyRGSIyQGCExQmKExAiJERIjJEZIjJAYITFCYoTECIkREiMkRkiMkBghMUJihMQIiRESIyRGSIyQGCExQmKExAiJERLzASI4BHnk0kZTAAAAAElFTkSuQmCC';
 */

  /* constructor(private elementRef: ElementRef) {} */

  ngOnInit() {
    // console.log('dolazy', this.dolazy);

    this.elementRef.nativeElement.dataset.srcset = this.dolazy;
    this.elementRef.nativeElement.dataset.sizes = 'auto';
    lazyLoad(this.elementRef.nativeElement, {
      hash: 'LKO2:N%2Tw=w]~RBVZRi};RPxuwH',
      hashType: 'blurhash',
    });
  }

  load() {
    this.className = 'image-loaded';
  }
}
